import { cx } from 'cva';
import { type ComponentProps, type FunctionComponent } from 'react';
import styles from './CircularButton.module.css';

export type CircularButtonProps = ComponentProps<'button'>;

export const CircularButton: FunctionComponent<CircularButtonProps> = ({
  className,
  ...props
}) => {
  return (
    <button className={cx(styles.root, className)} type="button" {...props} />
  );
};
